import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  const footerLinks = [
    { name: 'Privacy Policy', href: '/privacy' },
    { name: 'Terms and Conditions', href: '/terms' },
    { name: 'Contact Us', href: '/contact' },
  ];

  const handleLinkClick = (e, href) => {
    e.preventDefault();
    navigate(href);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="border-t border-warm-border py-8 px-6">
      <div className="max-w-[1100px] mx-auto flex items-center justify-between flex-wrap gap-4">
        <div className="flex items-center gap-2">
          {/* <div className="w-6 h-6 rounded-md bg-accent flex items-center justify-center">
            <span className="text-white font-bold text-xs font-serif">R</span>
          </div> */}
          <span className="text-4xl font-semibold text-warm-text">EzDaily</span>
          <span className="text-xs text-warm-textMuted ml-2">© {currentYear} EzDaily Inc. All rights reserved.</span>
        </div>
        <div className="flex gap-6">
          {footerLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              onClick={(e) => handleLinkClick(e, link.href)}
              className="text-xs text-warm-textMuted hover:text-warm-textSub transition-colors cursor-pointer"
            >
              {link.name}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
